import axios from "axios";
import {
  type ConstructionProfile,
  UpdateConstructionProfileRequest,
} from "../../../types/model/constructionProfile";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;

export const updateCaptureConstructionProfile = async (
  captureId: number,
  constructionProfileId: number,
  payload: UpdateConstructionProfileRequest,
): Promise<ConstructionProfile> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.put(
    `${BASE_URL}/${captureId}/construction-profile/${constructionProfileId}`,
    payload,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
